import '@fontsource-variable/bricolage-grotesque'
import '@fontsource-variable/montserrat'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { TanStackDevtools } from '@tanstack/react-devtools'
import { formDevtoolsPlugin } from '@tanstack/react-form-devtools'
import type { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import NotFoundPage from '~/components/communication/NotFoundPage'
import { Toaster } from '~/components/ui/sonner'
import '~/lib/zod-errors'
import GlobalProvider from '../components/GlobalProvider'
import KioskNotificationComponent from '../components/KiosksNotificationComponent'
import VisioComponent from '../components/VisioComponent'

interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootDocument,
  notFoundComponent: NotFoundPage,
})

function RootDocument() {
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <GlobalProvider>
        <Outlet />
        <TanStackDevtools
          plugins={[
            {
              name: 'TanStack Router',
              render: <TanStackRouterDevtoolsPanel />,
            },
            { name: 'TanStack Query', render: <ReactQueryDevtoolsPanel /> },
            formDevtoolsPlugin(),
          ]}
        />
        <KioskNotificationComponent />
        <VisioComponent />
        <Toaster richColors position="bottom-center" toastOptions={{ style: { width: '600px' } }} />
      </GlobalProvider>
    </LocalizationProvider>
  )
}
